module.exports = __webpack_public_path__ + "img/nie_logo.06d3dc50.png";